import * as OperatorService from 'js/services/api/entity/operator.js'
import _ from 'lodash'

import * as consts from './constants'

const getActiveTravelBucket = rootGetters => (
  String(rootGetters['user/mediaType']) === String(consts.QR_ID_MEDIA_TYPE)
    ? 'accountTravels'
    : String(rootGetters['user/mediaType']) === String(consts.TSC_MEDIA_TYPE)
      ? 'tscTravels'
      : 'travels'
)

export default {
  journeys: {
    state: {
      travels: [],
      operators: new Map(),
      travelTypes: [
        consts.VALIDATION_TYPE,
        consts.TNE_VALIDATION_TYPE,
        consts.PARTIAL_VALIDATION_TYPE
      ]
    },

    getters: {
      /**
       * Retreives the journey details. You can order ascending or descending (by timestamp)
       * @param {orderDir} (asc|*desc)
       * @returns
      */
      travels: (state, getters, rootState, rootGetters) => {
        const activeBucket = getActiveTravelBucket(rootGetters)

        if (activeBucket === 'accountTravels') return getters.accountTravels
        if (activeBucket === 'tscTravels') return getters.tscTravels

        return state.travels
      },

      /**
       * Filters are set in the filter store.
       * Any selected filters will be applied to the array before returning the results
       * @returns {Array}
       */
      filteredJourneys(state, getters) {
        return getters.travels
      },

      journeysByYearMonth(state, getters) {
        const output = {}
        const journeys = getters.filteredJourneys

        if (_.isEmpty(journeys)) return output

        journeys.forEach(item => {
          if (!output[item.year]) output[item.year] = {}

          if (!output[item.year][item.monthIndex]) {
            output[item.year][item.monthIndex] = {}
          }

          if (!output[item.year][item.monthIndex][item.day]) {
            output[item.year][item.monthIndex][item.day] = []
          }

          output[item.year][item.monthIndex][item.day].push(item)
        })

        return output
      },

      operators: state => state.operators,

      operatorsIds(state) {
        const ids = new Set()
        state.operators.forEach(item => {
          ids.add(item.id)
        })

        return ids
      },

      operatorById: state => id => state.operators.get(id)
    },

    mutations: {
      setTravels(state, val) {
        state.travels = val
      },
      setTravelTypes(state, val) {
        if(Array.isArray(val)) state.travelTypes = val
      },
      pushOperator(state, val) {
        state.operators.set(val.id, val)
      },
      setOperators(state, val) {
        state.operators = val
      }
    },

    actions: {
      /**
       * At present we have no operator information available in passenger.
       * This action reads the operator ids list from
       * the municipity and retreives their data from back
       */
      getOperators({rootGetters, dispatch}) {
        if (_.isEmpty(rootGetters['administrativeArea/getOperatorIds'])) return

        rootGetters.getOperatorIds.forEach(op => {
          OperatorService.getOperator(op)
            .then(response => {
              dispatch('addOperator', response)
            })
            .catch(error => {
              console.log('Error getting operator details', error)
            })
        })
      },

      /**
       * I have been unable to use this endpoint as it
       * seems to require authentication against the operator platform
       */
      getAllOperators({rootGetters, dispatch}) {
        const areaId = rootGetters['administrativeArea/administrativeAreaId']
        OperatorService.getOperatorsData(areaId)
          .then(response => {
            dispatch('setOperators', response.data)
          })
          .catch(error => {
            console.log('Error getting operator details', error)
          })
      },

      /**
       * Push operator to the array if not already included
       * The getter uses a Set for performance reasons
       * */
      addOperator({getters, commit}, operator) {
        if (!getters.operatorsIds.has(operator)) {
          commit('pushOperator', operator)
        }
      }

    }
  }
}
